import { LevelBadge, DivisionBadge } from "./Badges";

export default function TeamCard({ team, onOpen }) {
  return (
    <div
      onClick={() => onOpen(team)}
      style={{
        background: "#111827", border: "1px solid #1f2937", borderRadius: 14,
        padding: "20px 22px", cursor: "pointer", transition: "all 0.18s",
        position: "relative", overflow: "hidden"
      }}
      onMouseEnter={e => {
        e.currentTarget.style.borderColor = team.colour;
        e.currentTarget.style.transform = "translateY(-2px)";
        e.currentTarget.style.boxShadow = `0 8px 30px ${team.colour}30`;
      }}
      onMouseLeave={e => {
        e.currentTarget.style.borderColor = "#1f2937";
        e.currentTarget.style.transform = "";
        e.currentTarget.style.boxShadow = "";
      }}
    >
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: team.colour, borderRadius: "14px 14px 0 0" }} />

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          {team.badge_url
            ? <img src={team.badge_url} alt={team.club} style={{ width: 40, height: 40, borderRadius: "50%", objectFit: "cover", border: "2px solid #1f2937", background: "#1f2937" }} onError={e => { e.target.style.display="none"; e.target.nextSibling.style.display="inline"; }} />
            : null}
          <span style={{ fontSize: 26, display: team.badge_url ? "none" : "inline" }}>{team.badge || "⚽"}</span>
          <div>
            <div style={{ color: "#f9fafb", fontFamily: "'Oswald', sans-serif", fontSize: 16, fontWeight: 700, lineHeight: 1.1 }}>{team.club}</div>
            <div style={{ color: "#6b7280", fontSize: 11, marginTop: 2 }}>{team.town} · {team.day}</div>
          </div>
        </div>
        <div style={{ background: "#1f2937", color: "#f9fafb", fontFamily: "'Oswald', sans-serif", fontWeight: 700, fontSize: 18, borderRadius: 8, padding: "3px 10px", letterSpacing: 1 }}>
          {team.ageGroup}
        </div>
      </div>

      <div style={{ color: "#6b7280", fontSize: 11, marginBottom: 10 }}>{team.league}</div>

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        <DivisionBadge division={team.division} />
        <LevelBadge level={team.level} />
      </div>

      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginBottom: 10 }}>
        {team.positions.map(p => (
          <span key={p} style={{ background: "#1f2937", color: "#d1d5db", borderRadius: 20, padding: "3px 10px", fontSize: 11, fontWeight: 600 }}>📍 {p}</span>
        ))}
      </div>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span style={{ color: "#4b5563", fontSize: 11 }}>Posted {team.posted}</span>
        <span style={{ color: team.colour, fontSize: 12, fontWeight: 700, fontFamily: "'Oswald', sans-serif" }}>VIEW →</span>
      </div>
    </div>
  );
}
